/* global globalThis */
import { configureStore, combineReducers } from "@reduxjs/toolkit";
import { persistStore, persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
import authReducer, { logout } from "./slices/authSlice";
import togglesReducer from "./slices/togglesSlice";
import membersFiltersReducer from "./slices/membersFilterSlice";
import cagMappingsReducer from "./slices/cagMappingsSlice";
import internationalFilterReducer from "./slices/internationalFilterSlice";

const membersFiltersPersistConfig = {
  key: "membersFilters",
  storage,
};

const cagMappingsPersistConfig = {
  key: "cagMappingsFilters",
  storage,
};
const internationalFiltersPersistConfig = {
  key: "internationalFilters",
  storage,
};

const appReducer = combineReducers({
  auth: authReducer,
  toggles: togglesReducer,
  membersFilters: persistReducer(
    membersFiltersPersistConfig,
    membersFiltersReducer,
  ),
  cagMappingsFilters: persistReducer(
    cagMappingsPersistConfig,
    cagMappingsReducer,
  ),
  internationalFilters: persistReducer(
    internationalFiltersPersistConfig,
    internationalFilterReducer,
  ),
});

const rootReducer = (state, action) => {
  if (action.type === logout.type) {
    storage.removeItem("persist:membersFilters");
    storage.removeItem("persist:cagMappingsFilters");
    storage.removeItem("persist:internationalFilters");
    return appReducer(undefined, action);
  }
  return appReducer(state, action);
};

const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});

globalThis.addEventListener("storage", (event) => {
  if (event.key === "token" && !event.newValue) {
    store.dispatch(logout());
  }
});

const persistor = persistStore(store);

export { logout } from "./slices/authSlice";
export { persistor };
export default store;
